export default "__VITE_ASSET__DXNcq81e__"